import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ isAiLm: boolean; isDisabled: boolean }>()(
  (theme, { isAiLm, isDisabled }) => ({
    box: {
      background: theme.secondary.s1,
      borderRadius: theme.borderRadius.md,
      padding: '8px 16px',
      width: '100%',
    },
    inner: {
      ...dFlex(),
      flexDirection: 'column',
      gap: 16,
      width: '100%',
    },
    text: {
      ...dFlex('start'),
    },
    tabs: {
      width: 'auto',
      padding: '0 2px',

      ...(isDisabled && {
        opacity: 0.5,
      }),

      [theme.breakpoints.down(Breakpoint.Sm)]: {
        width: '100%',
      },

      '& .MuiTab-root.MuiButtonBase-root': {
        padding: '8px 10px',
        minWidth: 181,

        [theme.breakpoints.down(Breakpoint.Sm)]: {
          minWidth: '50%',
        },

        ...(isAiLm && {
          '&.Mui-selected': {
            background: theme.gradient.g2,

            '&:focus': {
              background: theme.gradient.g2,
            },

            '&:active': {
              background: theme.gradient.g2,
            },

            ...(isDisabled && {
              background: theme.gradient.g2,
            }),
          },
        }),
      },
    },
    topPanel: {
      ...dFlex('space-between'),
      width: '100%',

      [theme.breakpoints.down(Breakpoint.Sm)]: {
        alignItems: 'start',
        flexDirection: 'column',
        gap: 16,
      },
    },
    bottomPanel: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 16,

      [theme.breakpoints.down(Breakpoint.Sm)]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 8,
      },
    },
    btn: {
      background: theme.primary.p3,
    },
    activeQuickBtn: {
      '&.MuiButtonBase-root': {
        background: theme.primary.p3,
      },
    },
  }),
);

export default useStyles;
